module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sky-overlay",
    class: [_vm.name, {
      active: _vm.active
    }],
    style: (_vm.overlayStyle)
  }, [_c('transition', {
    attrs: {
      "name": "sky-overlay"
    },
    on: {
      "enter": _vm.enter,
      "enter-cancelled": _vm.leave,
      "leave": _vm.leave,
      "leave-cancelled": _vm.enter,
      "after-leave": _vm.afterLeave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active),
      expression: "active"
    }],
    staticClass: "sky-overlay-container",
    attrs: {
      "keep-alive": ""
    }
  }, [_c('div', {
    staticClass: "sky-overlay-close"
  }, [_c('button', {
    staticClass: "sky-overlay-close-button",
    on: {
      "click": _vm.toggle
    }
  }, [_c('sky-svg', {
    attrs: {
      "name": "close"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "sky-overlay-content"
  }, [_vm._t("default")], 2)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6713ge/master/~/vue-loader/lib/template-compiler?{"id":"data-v-7903b972"}!./scripts/sky-overlay/sky-overlay.html
// module id = 361
// module chunks = 1